var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15947 6.96232C0.894223 7.22756 0.464177 7.22756 0.198933 6.96232C-0.0663109 6.69707 -0.0663109 6.26703 0.198933 6.00178L3.08053 3.12018C3.34578 2.85494 3.77582 2.85494 4.04107 3.12018C4.30631 3.38543 4.30631 3.81547 4.04107 4.08072L1.15947 6.96232Z",
    fill: "#9D9ABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.198933 1.15947C-0.066311 0.894223 -0.066311 0.464177 0.198933 0.198933C0.464177 -0.066311 0.894222 -0.066311 1.15947 0.198933L4.04107 3.08053C4.30631 3.34578 4.30631 3.77582 4.04107 4.04107C3.77582 4.30631 3.34578 4.30631 3.08053 4.04107L0.198933 1.15947Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryArrow);
export default __webpack_public_path__ + "static/media/HistoryArrow.4cd70959.svg";
export { ForwardRef as ReactComponent };